import { ContainedIcon } from '@frontend/icons';
import { theme } from '@frontend/theme';

export const Critical = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 2,
        borderRadius: theme.borderRadius.small,
      }}
      iconName='ai-critical'
      background={theme.colors.gradients.critical}
      color={theme.colors.critical70}
    />
  );
};
